import React from 'react'
import {ActionSheet, ActionSheetButton} from 'react-onsenui'
import connect from "react-redux/es/connect/connect";
import {withRouter} from "react-router-dom";
import {showToastMessage} from "../../../modules/toast";
import {showAlertMessage} from "../../../modules/alert";
import {OPEN_EXTERNAL_LINK} from "../../../modules/variable/common_variable";


class NavigationActionSheet extends React.Component {
    state = {
    };

    componentDidMount() {

    }

    componentWillReceiveProps(nextProps){

    }

    render() {
        const NSAS = this.props.NSAS;

        return (
            <div>
                <ActionSheet className="share-action-sheet" isOpen={NSAS.open} animation='default' modifier={'material'} onCancel={() => this.props.hide()} isCancelable={true}>
                    <div className="action-sheet-title action-sheet-title--material">
                        내비게이션 선택
                        <button className="button--material--flat" onClick={() => this.props.showAlertMessage("안드로이드나 아이폰 앱에서만 정상 작동합니다. 네이버 지도의 경우 스마트폰에 네이버 지도 앱이 설치되어 있어야 내비게이션이 실행됩니다.", "내비게이션 안내")}>
                            <span>내비가 실행되지 않을 때</span>
                        </button>
                    </div>
                    <ul className="list list--material">
                        <li className="list-item list-item--material" onClick={() => OPEN_EXTERNAL_LINK("http://m.tmap.co.kr/tmap2/mobile/route.jsp?name=" + encodeURIComponent(NSAS.target.name) + "&lon="+ NSAS.target.x +"&lat="+ NSAS.target.y)}>
                            <div className="list-item__left list-item--material__left">
                                <img className="list-item__thumbnail"
                                     src={'/assets/image/logo/ico_mnavi2.png'}
                                     alt={'tmap_btn'}/>
                            </div>
                            <div className="list-item__center list-item--material__center">
                                <div className="list-item__title list-item--material__title">티맵</div>
                            </div>
                        </li>
                        <li className="list-item list-item--material" onClick={() => OPEN_EXTERNAL_LINK("nmap://navigation?dlat=" + NSAS.target.y + "&dlng=" + NSAS.target.x + "&dname=" + encodeURIComponent(NSAS.target.name) + "&appname=com.hopse.picnici")}>
                            <div className="list-item__left list-item--material__left">
                                <img className="list-item__thumbnail"
                                     src={'/assets/image/logo/ico_mnavi3.png'}
                                     alt={'navermap_btn'}/>
                            </div>
                            <div className="list-item__center list-item--material__center">
                                <div className="list-item__title list-item--material__title">네이버 지도</div>
                            </div>
                        </li>
                        <li className="list-item list-item--material" onClick={() => OPEN_EXTERNAL_LINK('https://picnicisub.firebaseapp.com/kakao_navi.html?y=' + NSAS.target.y + '&x=' + NSAS.target.x + '&name=' + encodeURIComponent(NSAS.target.name))}>
                            <div className="list-item__left list-item--material__left">
                                <img className="list-item__thumbnail"
                                     src={'/assets/image/logo/ico_mnavi1.png'}
                                     alt={'kakaonavi_btn'}/>
                            </div>
                            <div className="list-item__center list-item--material__center">
                                <div className="list-item__title list-item--material__title">카카오 내비</div>
                            </div>
                        </li>
                    </ul>
                    <ActionSheetButton className="action-sheet-close TUTO_CLOSE_SHARE_BUTTON" onClick={() => this.props.hide()} icon={'md-close'} modifier={'material'}>내비게이션 선택 닫기</ActionSheetButton>
                </ActionSheet>
            </div>
        )
    }
}

const mapStateToProps = ({ user }) => ({
    userInfo: user.userInfo,
});

const mapDispatchToProps = dispatch => ({
    showAlertMessage: (message, title) => dispatch(showAlertMessage(message, title)),
    showToastMessage: message => dispatch(showToastMessage(message)),
});

export default withRouter(connect(
    mapStateToProps,
    mapDispatchToProps
)(NavigationActionSheet))

